import {
  SnackbarNotifier,
  ProgressNotifier,
  Hud,
} from '@mvf/product-components';
import { IHudPresetContextState } from '@mvf/product-components/contexts';
import { OtherPages } from './OtherPages/OtherPages';
import { ReactNode } from 'react';
import { Page } from './Page';
import {
  Navigate,
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router';
import { HoldingPage } from './HoldingPage/HoldingPageConnector';

export const presets: IHudPresetContextState = {
  defaultHud: {},
};

const defaultHud = (page: ReactNode) => (
  <Hud
    preset="defaultHud"
    progressBar={<ProgressNotifier />}
    notifier={<SnackbarNotifier />}
  >
    {page}
  </Hud>
);

const routes = (
  <Route>
    <Route path={Page.HOLDING} element={defaultHud(<HoldingPage />)} />
    <Route
      path={Page.BRAND_LINK}
      element={<Navigate replace to={Page.HOLDING} />}
    />
    <Route path="*" element={<OtherPages />} />
  </Route>
);

export const router = createBrowserRouter(createRoutesFromElements(routes));
